export default __webpack_public_path__ + "static/media/bv-watches-bg.bd31cbdb.png";